import { createSlice } from "@reduxjs/toolkit";

export const loadingSlice = createSlice({
  name: "loading",
  initialState: false, // primitive boolean
  reducers: {
    setLoading: (state, action) => {
      const val = Boolean(action.payload);
      // DEBUG
      console.log(
        "%c[LoaderSlice] setLoading ->",
        "color:#c41",
        val,
        new Error().stack?.split("\n").slice(2, 6).join("\n")
      );
      return val; // <-- replace state, don't mutate a property
    },
  },
});

export const { setLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
